import { create } from "zustand";
import { photosApi } from "@/api";

const usePhotoStore = create((set, _get) => ({
  photos: [],
  uploading: false,
  error: null,

  fetchPhotos: async (expertiseId) => {
    try {
      set({ error: null });
      const photos = await photosApi.list(expertiseId);
      set({ photos });
    } catch (err) {
      set({ error: err.message });
    }
  },

  uploadPhoto: async (expertiseId, file, categorie = "exterieur", legende = "") => {
    try {
      set({ uploading: true, error: null });
      const photo = await photosApi.upload(expertiseId, file, categorie, legende);
      set((state) => ({ photos: [...state.photos, photo], uploading: false }));
      return photo;
    } catch (err) {
      set({ uploading: false, error: err.message });
      throw err;
    }
  },

  updatePhoto: async (photoId, data) => {
    try {
      set({ error: null });
      const updated = await photosApi.update(photoId, data);
      set((state) => ({
        photos: state.photos.map((p) => (p.id === photoId ? updated : p)),
      }));
    } catch (err) {
      set({ error: err.message });
    }
  },

  reorderPhotos: async (expertiseId, items) => {
    try {
      set({ error: null });
      const photos = await photosApi.reorder(expertiseId, items);
      set({ photos });
    } catch (err) {
      set({ error: err.message });
    }
  },

  deletePhoto: async (photoId) => {
    try {
      set({ error: null });
      await photosApi.delete(photoId);
      set((state) => ({
        photos: state.photos.filter((p) => p.id !== photoId),
      }));
    } catch (err) {
      set({ error: err.message });
    }
  },
}));

export default usePhotoStore;
